document.addEventListener("DOMContentLoaded", () => {

  // get the first media image ONLY inside .gfs-variant-product
  var firstImage = document.querySelector('.gfs-variant-product #Slide-Thumbnails-template--18251386585162__main-1');

  if (firstImage) {
      // find the button inside this element
      var firstBtn = firstImage.querySelector('button');
      if (firstBtn) {
          firstBtn.click();
      }
  }

  //--------- Product Contact Form
  const productContactForm = document.getElementById("product--contact-form");

  if (productContactForm) {
    productContactForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const form = e.target;
      const formData = new FormData(form);

      const emailInput = document.getElementById("client_email");
      const email = emailInput.value.trim();
      const errorMsg = document.getElementById("email-error");

      errorMsg.style.display = "none";

      // Basic email pattern
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(email)) {
        errorMsg.style.display = "block";
        alert("Please enter a valid email address.");
        return;
      }

      // Prevent multiple submissions
      if (productContactForm.classList.contains("submitting")) return;
      productContactForm.classList.add("submitting");

      document.querySelector("#product--contact-form .loader").style.display = "block";
      document.querySelector("#product--contact-form .form-actions").style.display = "none";

      try {
        const response = await fetch("https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/inquiry", {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.error) {
          alert("Error: " + result.error);
          productContactForm.classList.remove("submitting");
          document.querySelector("#product--contact-form .loader").style.display = "none";
          document.querySelector("#product--contact-form .form-actions").style.display = "flex";
          return;
        }

        const inquiry_id = result.inquiry_id;
        if (!inquiry_id) {
          alert("Something went wrong. Inquiry ID is missing.");
          productContactForm.classList.remove("submitting");
          document.querySelector("#product--contact-form .loader").style.display = "none";
          document.querySelector("#product--contact-form .form-actions").style.display = "flex";
          return;
        }

       // alert("Mail sent successfully!");

        // Show success and hide form
        document.querySelector("#product--contact-form .form-actions").style.display = "none";
        document.querySelector("#product--contact-form .product-information").style.display = "none";
        document.querySelector("#product--contact-form #product--contact-form").style.display = "none";
        document.querySelector("#product--contact-form .loader").style.display = "none";
        document.querySelector("#product--contact-form .thank-you-message").style.display = "block";

      } catch (error) {
        console.error("Submission failed:", error);
        alert("Something went wrong. Please try again.");
        document.querySelector("#product--contact-form .loader").style.display = "none";
        document.querySelector("#product--contact-form .form-actions").style.display = "flex";
      }
    });
  }

  document.querySelectorAll('.closer-look .link').forEach(linkElement => {
    const popupButton = document.getElementById('ProductPopup-gfs-contact-us-form');

    if (popupButton) {
      linkElement.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior if needed
        popupButton.click();
      });
    }
  });


  // ADD TO CART - FOOTER
  const quickAdd = document.getElementById("product-quick-addtocart");
  let trustBar = document.getElementById("shipping-partner-payment");
  /*if (window.innerWidth <= 901) {
    trustBar = document.getElementById("product-additional-info-mobile");
  }*/
  const faq = document.getElementById("faq-product");

  if (!quickAdd || !trustBar || !faq) return;

  function updateQuickAddVisibility() {
    const scrollY = window.scrollY || window.pageYOffset;
    const windowH = window.innerHeight;

    const trustTop = trustBar.offsetTop;
    const trustBottom = trustTop + trustBar.offsetHeight;
    const faqTop = faq.offsetTop;
    const faqBottom = faqTop + faq.offsetHeight;

    const trustVisible = scrollY + windowH > trustTop && scrollY < trustBottom;
    const faqVisible = scrollY + windowH > faqTop && scrollY < faqBottom;

    // In between = scrolled past trustBar but not yet reached faq
    const betweenTrustAndFaq = scrollY > trustBottom && scrollY < faqTop;

    if (trustVisible || faqVisible || betweenTrustAndFaq) {
      quickAdd.classList.add("show-quick-add");
    } else {
      quickAdd.classList.remove("show-quick-add");
    }
  }

  window.addEventListener("scroll", updateQuickAddVisibility, { passive: true });
  window.addEventListener("resize", updateQuickAddVisibility);
  updateQuickAddVisibility(); // run once on load

  // previous - next product
  document.addEventListener("click", function (e) {
    // Only for screens wider than 901px
    if (window.innerWidth <= 901) return;

    const prev = e.target.closest(".previous-product");
    const next = e.target.closest(".next-product");

    if (prev) {
      const link = prev.querySelector(".previous-product-details a");
      if (link) link.click();
    }

    if (next) {
      const link = next.querySelector(".next-product-details a");
      if (link) link.click();
    }
  });

  // Main FAQ 
  const faqWrapper = document.querySelector('.faq-list'); // parent element
  if (faqWrapper){
    faqWrapper.addEventListener('click', (e) => {
      const item = e.target.closest('.faq--item');
      if (!item) return;

      const isActive = item.classList.contains('active');
      document.querySelectorAll('.faq--item').forEach(i => i.classList.remove('active'));
      if (!isActive) item.classList.add('active');
    });
  }

  // credit - debit
  document.addEventListener("click", function (e) {
    if (window.innerWidth <= 900) {
      const infoBox = document.querySelector(".shopify-payment-additional-info");

      if (!infoBox) return;

      if (e.target.closest(".shopify-payment-button__more-options")) {
        // If clicked on the button → toggle
        infoBox.classList.toggle("active");
      } else {
        // If clicked anywhere else → remove
        infoBox.classList.remove("active");
      }
    }
  });


  // add-to-cart
  (function () {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      // Capture the button that triggered the fetch
      const button = document.activeElement;

      // Only run for these specific add-to-cart buttons
      const isAllowedButton = button && (
          button.matches('#product-quick-addtocart .product-form__submit') ||
          button.matches('.product__info-container .product-form__submit')
        );

      // If it's not one of the allowed buttons, continue normally
      if (!isAllowedButton) {
        return originalFetch.apply(this, args);
      }

      return originalFetch.apply(this, args).then(response => {

        if ( response.ok && response.url.includes('/add') && response.status === 200 ) {
          setTimeout(() => {
            button.classList.add('add_cart_success');
            button.disabled = true;

            const span = button.querySelector('span');

            if (span) {
              span.textContent = '✔ Added';
            }
          }, 500);
        }

        return response;
      });
    };
  })();
});

/* Product Additional Functionality */
 document.addEventListener('DOMContentLoaded', function() {
    // Tab functionality
  // Find all tab containers on the page (can be in multiple sections)
  const tabContainers = document.querySelectorAll('.tab-container');

  tabContainers.forEach(container => {
    const tabBtns = container.querySelectorAll('.tab-btn');
    const tabPanes = container.querySelectorAll('.tab-pane');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const targetTabId = this.getAttribute('data-tab');

        // Remove 'active' from all buttons and panes in this container
        tabBtns.forEach(b => b.classList.remove('active'));
        tabPanes.forEach(p => p.classList.remove('active'));

        // Add 'active' to clicked button and matching pane
        this.classList.add('active');
        const targetPane = container.querySelector(`#${targetTabId}`);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });

  // FAQ functionality
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement;
      const faqAnswer = faqItem.querySelector('.faq-answer');
      const isActive = faqItem.classList.contains('active');

      // Close all items
      document.querySelectorAll('.faq-item').forEach(item => item.classList.remove('active'));
      document.querySelectorAll('.faq-answer').forEach(answer => answer.classList.remove('active'));

      // If it was not active before, open it
      if (!isActive) {
        faqItem.classList.add('active');
        faqAnswer.classList.add('active');
      }
    });
  });

  // Mobile Accordion
  const tabTitles = document.querySelectorAll('.tab-title');

  tabTitles.forEach(tabTitle => {
    tabTitle.addEventListener('click', function() {
      const tabItem = this.parentElement;
      const tabDesc = tabItem.querySelector('.tab-desc');
      const isActive = tabItem.classList.contains('active');

      // Close all items
      document.querySelectorAll('.tab-item').forEach(item => item.classList.remove('active'));
      document.querySelectorAll('.tab-desc').forEach(desc => desc.classList.remove('active'));

      // If it was not active before, open it
      if (!isActive) {
        tabItem.classList.add('active');
        tabDesc.classList.add('active');

        // Scroll to tab with 100px offset from top
        const elementTop = tabItem.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementTop - 100, // offset upwards
          behavior: "smooth"
        });
      }
    });
  });
});

/*
* Thumbnail Slider
*/

(function () {
  const THUMB_SELECTOR = '.thumbnail-slider ul.thumbnail-list';
  const WRAP_SELECTOR = '.thumbnail-slider .product-scroller';
  const PREV_SELECTOR = '.thumbnail-slider .slider-button--prev';
  const NEXT_SELECTOR = '.thumbnail-slider .slider-button--next';

  if (window.innerWidth < 900) return;

  const slider = document.querySelector(THUMB_SELECTOR);
  const wrapper = document.querySelector(WRAP_SELECTOR);
  const prevBtn = document.querySelector(PREV_SELECTOR);
  const nextBtn = document.querySelector(NEXT_SELECTOR);

  if (!slider || !wrapper || !prevBtn || !nextBtn) return;

  const scrollAmount = 120;

  /* ---------- FORCE ENABLE BUTTONS ---------- */
  function forceEnable() {
    prevBtn.disabled = false;
    nextBtn.disabled = false;
    prevBtn.removeAttribute('aria-disabled');
    nextBtn.removeAttribute('aria-disabled');
  }

  forceEnable();

  /* ---------- OBSERVE SHOPIFY RE-DISABLING ---------- */
  const observer = new MutationObserver(forceEnable);

  observer.observe(prevBtn, {
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });

  observer.observe(nextBtn, {
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });

  /* ---------- SCROLL HANDLERS (CAPTURE PHASE) ---------- */
  prevBtn.addEventListener(
    'click',
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      slider.scrollTop -= scrollAmount;
      forceEnable();
    },
    true //CAPTURE MODE — runs before Shopify
  );

  nextBtn.addEventListener(
    'click',
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      slider.scrollTop += scrollAmount;
      forceEnable();
    },
    true
  );
})();

(function () {

  function forceMute(video) {
    if (!video) return;

    // Remove controls COMPLETELY
   // video.removeAttribute('controls');
  //  video.controls = false;

    // Force mute
    video.muted = true;
    video.volume = 0;

    // Lock mute permanently
    video.addEventListener('volumechange', function () {
      video.muted = true;
      video.volume = 0;
    });
  }

  function processVideos(root = document) {
    root.querySelectorAll('video').forEach(forceMute);
  }

  // Initial run (in case video already exists)
  processVideos();

  // Observe Dawn injecting video dynamically
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;

        if (node.tagName === 'VIDEO') {
          forceMute(node);
        } else if (node.querySelectorAll) {
          processVideos(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


/** Page View Datalayer */
document.addEventListener("DOMContentLoaded", function () {

  // View Item on page load
  send_view_data_layer("view_item_ce");

  // Click tracking ONLY for payment button
  document.addEventListener("click", function (e) {
    const wrapper = e.target.closest('[data-shopify="payment-button"]');
    if (wrapper) {
      send_data_layer("add_to_cart_ce");
      //send_data_layer("begin_checkout_ce");
    } 
  });

  function send_data_layer(event){

    var productEl = document.querySelector(".gfs-specifications .product--info");
    if (!productEl) return;

    var sizeEl = document.querySelector(".gfs-specifications .gfs-spec-size-item");

    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    var price = parseInt(productEl.dataset.price || 0, 10);

    var item = {
      item_id: productEl.dataset.sku || productEl.dataset.id,
      item_name: productEl.dataset.title || "",
      affiliation: productEl.dataset.origin || "",
      item_category: productEl.dataset.type || "",
      item_category2: productEl.dataset.treatment || "",
      item_variant: sizeEl ? sizeEl.dataset.size : "",
      item_list_id: productEl.getAttribute("parent-id") || "",
      item_list_name: productEl.getAttribute("parent-title") || "",
      price: price,
      quantity: 1,
      item_brand : "Gemstones For Sale",
      index:0,
      listing_date: productEl.dataset.publish || "" ,
      coupon:"NA",
      discount : 0
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: event,
      page_type: "product_page",
      platform: platform,
      total_qty : item.length,  
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status || "guest",
      ecommerce: {
        currency: "USD",
        value: price,             
      coupon:"NA",
        items: [item]
      }
    });

    //console.log("GA4 event fired:", event, item);

     // ── NEW: publish custom event so CE pixel can receive it ──
        if (window.Shopify?.analytics?.publish) {
          const publishPayload = {
            item_list_id: item.item_list_id,
            item_list_name: item.item_list_name,
            item_category2: item.item_category2,
            affiliation: item.affiliation,
            listing_date: item.listing_date,
            index: item.index
          };

          console.log("[DEV] Publishing ga4_product_context with:", publishPayload);
          window.Shopify.analytics.publish('ga4_product_context', publishPayload);
        }
  }

  function send_view_data_layer(event){

    var productEl = document.querySelector(".gfs-specifications .product--info");
    if (!productEl) return;

    var sizeEl = document.querySelector(".gfs-specifications .gfs-spec-size-item");

    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";
    var price = parseInt(productEl.dataset.price || 0, 10);

    var item = {
      item_id: productEl.dataset.sku || productEl.dataset.id,
      item_name: productEl.dataset.title || "",
      affiliation: productEl.dataset.origin || "",
      item_category: productEl.dataset.type || "",
      item_category2: productEl.dataset.treatment || "",
      item_variant: sizeEl ? sizeEl.dataset.size : "",
      item_list_id: productEl.getAttribute("parent-id") || "",
      item_list_name: productEl.getAttribute("parent-title") || "",
      price: price,
      quantity: 1,
      item_brand : "Gemstones For Sale",
      index:0,
      listing_date: productEl.dataset.publish || "" ,
      coupon:"NA",
      discount : 0
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: event,
      page_type: "product_page",
      platform: platform,
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status || "guest",
      ecommerce: {
        currency: "USD",
        value: price,
        items: [item]
      }
    });

    //console.log("GA4 event fired:", event, item);
  }

});